/* tslint:disable:max-line-length */
/**
 * 1
 * Alza API 1
 * Alza Rest Api Swagger Documentation
 *   "path": null
 */

import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Observable'

import * as model from '../model'

export interface SearchParams {
  /**
   * Category Id (On Category Page)
   * format: int32
   */
  categoryId?: number
  /**
   * Commodity Id (On Commodity Detail)
   * format: int32
   */
  commodityId?: number
  /** Ids Of Producers (Filter on e.g. Samsung) */
  producers?: number[]
  /** Client Url - Url Client Is Currently On */
  url?: string
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface GetConversationsParams {
  /**
   * To Return Conversations Created From (Datetime)
   * format: date-time
   */
  from?: string
  /** format: int32 */
  limit?: number
  /** format: int32 */
  offset?: number
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface CreateConversationParams {
  model?: model.CreateConversationRequestBodyModelV1
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface GetConversationParams {
  /**
   * Conversation Id
   * format: uuid
   */
  conversationId: string
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface GetMessagesParams {
  /**
   * Conversation Id - To Retrieve Messages Of Conversation
   * format: uuid
   */
  conversationId: string
  /**
   * From Datetime
   * format: date-time
   */
  from?: string
  /**
   * Items Limit
   * format: int32
   */
  limit?: number
  /**
   * Pagination Offset
   * format: int32
   */
  offset?: number
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface CreateSoundMessageParams {
  /**
   * Conversation Id
   * format: uuid
   */
  conversationId: string
  /** Id of Conversation */
  model?: model.UploadSoundRequestBodyModelV1
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface GetVendorTeamLimitedParams {
  /**
   * Vendor Team Id - To Retrieve Specific Vendor Team
   * format: int32
   */
  vendorTeamId: number
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface GetVendorConversationsParams {
  /**
   * To Return Conversations Created To (Datetime)
   * format: date-time
   */
  to?: string
  /** To Return Open/Closed Or All If Null */
  open?: boolean
  /**
   * To Return Conversations Of Team
   * format: int32
   */
  vendorTeamId?: number
  /** format: int32 */
  limit?: number
  /** format: int32 */
  offset?: number
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface GetVendorConversationsParamsV2 {
  /**
   * To Return Conversations Created To (Datetime)
   * format: date-time
   */
  to?: string
  /**
   * To Return Conversation State
   */
  conversationState: model.ConversationStateConversationV1Enum
  /**
   * To Return Conversations Of Team
   * format: int32
   */
  vendorTeamId?: number
  /**
   * To Return Conversations Of User
   * format: int32
   */
  vendorUserId: number
  /** format: int32 */
  limit?: number
  /** format: int32 */
  offset?: number
  /** The requested API version */
  version: 2
  /** Country parameter */
  country?: string
}

export interface GetVendorMessagesParams {
  /**
   * Conversation Id - To Retrieve Messages Of Conversation
   * format: uuid
   */
  conversationId: string
  /**
   * To Datetime
   * format: date-time
   */
  to?: string
  /** format: int32 */
  limit?: number
  /** format: int32 */
  offset?: number
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface GetVendorConversationParams {
  /**
   * Conversation Id
   * format: uuid
   */
  conversationId: string
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface CloseConversationParams {
  /**
   * Conversation Id
   * format: uuid
   */
  conversationId: string
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface EventsParams {
  /**
   * Id Of Conversation
   * format: uuid
   */
  conversationId: string
  /**
   * Id Of Conversation Event
   * format: int32
   */
  eventId: number
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface GetTeamsAndTeamMembersToAssignParams {
  /** format: int32 */
  limit?: number
  /** format: int32 */
  offset?: number
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface AssignConversationParams {
  /** Assignmnent Data */
  model?: model.AssignConversationRequestBodyModelV1
  /**
   * Conversation Id
   * format: uuid
   */
  conversationId: string
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface GetVendorConversationsTeamsParams {
  /** format: int32 */
  limit?: number
  /** format: int32 */
  offset?: number
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface GetVendorTeamsParams {
  /** format: int32 */
  limit?: number
  /** format: int32 */
  offset?: number
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface CreateVendorTeamParams {
  model?: model.CreateVendorTeamRequestBodyModelV1
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface GetVendorTeamParams {
  /**
   * Vendor Team Id - To Retrieve Specific Vendor Team
   * format: int32
   */
  vendorTeamId: number
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface UpdateVendorTeamParams {
  model?: model.UpdateVendorTeamRequestBodyModelV1
  /**
   * Vendor Team Id
   * format: int32
   */
  vendorTeamId: number
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface UploadVendorTeamImageParams {
  /** Image in Base64 */
  model?: model.UploadVendorTeamImageRequestBodyModelV1
  /**
   * Vendor Team Id
   * format: int32
   */
  vendorTeamId: number
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface LogoImgUrlParams {
  /** Image in Base64 */
  model?: model.UploadVendorTeamImageRequestBodyModelV1
  /**
   * Vendor Team Id
   * format: int32
   */
  vendorTeamId: number
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface GetVendorTeamOpeningHoursParams {
  /**
   * Vendor Team Id - To Retrieve Opening Hours Of Specific Vendor Team
   * format: int32
   */
  vendorTeamId: number
  /** format: int32 */
  limit?: number
  /** format: int32 */
  offset?: number
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface UpdateVendorTeamOpeningHoursParams {
  model?: model.UpdateOpeningHoursRequestBodyModelV1
  /**
   * Vendor Team Id
   * format: int32
   */
  vendorTeamId: number
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface GetVendorTeamRulesParams {
  /**
   * Vendor Team Id - To Retrieve Rules Of Specific Vendor Team
   * format: int32
   */
  vendorTeamId: number
  /** format: int32 */
  limit?: number
  /** format: int32 */
  offset?: number
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface CreateVendorTeamRuleParams {
  /** Vendor Team Rule */
  model?: model.CreateVendorTeamRuleRequestBodyModelV1
  /**
   * Vendor Team Id
   * format: int32
   */
  vendorTeamId: number
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface GetVendorTeamRuleParams {
  /**
   * Vendor Team Id - To Retrieve Rules Of Specific Vendor Team
   * format: int32
   */
  vendorTeamId: number
  /**
   * Vendor Team Rule It- To Delete The Selected Rule
   * format: int32
   */
  vendorTeamRuleId: number
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface DeleteVendorTeamRuleParams {
  /**
   * Vendor Team Id - To Retrieve Rules Of Specific Vendor Team
   * format: int32
   */
  vendorTeamId: number
  /**
   * Vendor Team Rule- To Delete The Selected Rule
   * format: int32
   */
  vendorTeamRuleId: number
  /** The requested API version */
  version: string
}

export interface UpdateVendorTeamRuleParams {
  model?: model.UpdateVendorTeamRuleRequestBodyModelV1
  /**
   * Team Id
   * format: int32
   */
  vendorTeamId: number
  /**
   * Rule Id
   * format: int32
   */
  vendorTeamRuleId: number
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface GetVendorTeamEshopsParams {
  /**
   * Vendor Team Id - To Retrieve Eshops Of Specific Vendor Team
   * format: int32
   */
  vendorTeamId: number
  /** format: int32 */
  limit?: number
  /** format: int32 */
  offset?: number
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface UpdateVendorTeamEshopsParams {
  model?: model.UpdateVendorTeamEshopsRequestBodyModelV1
  /**
   * Vendor Team Id
   * format: int32
   */
  vendorTeamId: number
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface GetTeamMembersParams {
  /**
   * Vendor Team Id - To Retrieve Teammembers of Specific Vendor Team
   * format: int32
   */
  vendorTeamId: number
  /** format: int32 */
  limit?: number
  /** format: int32 */
  offset?: number
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface CreateTeamMemberParams {
  model?: model.CreateTeammemberRequestBodyModelV1
  /**
   * Vendor Team Id - To Create Teammember of Specific Vendor Team
   * format: int32
   */
  vendorTeamId: number
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface GetTeamMemberParams {
  /**
   * Vendor Team Id - To Retrieve Teammember of Specific Vendor Team
   * format: int32
   */
  vendorTeamId: number
  /**
   * Teammember Id
   * format: int32
   */
  teamMemberId: number
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface DeleteTeamMemberParams {
  /**
   * Vendor Team Id - To Retrieve Teammember of Specific Vendor Team
   * format: int32
   */
  vendorTeamId: number
  /**
   * Teammember Id
   * format: int32
   */
  teamMemberId: number
  /** The requested API version */
  version: string
}

export interface GetTeamMemberRolesParams {
  /**
   * Vendor Team Id - To Retrieve Roles Of Specific Vendor Team Member
   * format: int32
   */
  vendorTeamId: number
  /**
   * Team Member Id - To Retrieve Roles Of Specific Vendor Team Member
   * format: int32
   */
  teamMemberId: number
  /** format: int32 */
  limit?: number
  /** format: int32 */
  offset?: number
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface GetVendorUsersParams {
  /** format: int32 */
  limit?: number
  /** format: int32 */
  offset?: number
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface GetVendorUserParams {
  /**
   * Vendor User Id - To Retrieve Specific Vendor User
   * format: int32
   */
  vendorUserId: number
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface UpdateVendorUserParams {
  model?: model.UpdateVendorUserRequestBodyModelV1
  /**
   * Vendor User Id
   * format: int32
   */
  vendorUserId: number
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface MeParams {
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface UploadVendorUserImageParams {
  /** Id of Vendor User */
  model?: model.UploadVendorUserImageRequestBodyModelV1
  /**
   * Vendor User Id
   * format: int32
   */
  vendorUserId: number
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface GetVendorUserTeamRolesParams {
  /**
   * Vendor User Id - To Retrieve Specific Vendor User Roles
   * format: int32
   */
  vendorUserId: number
  /** format: int32 */
  limit?: number
  /** format: int32 */
  offset?: number
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface DownloadConversationReportParams {
  /**
   * Vendor team ID to get report file
   * format: int32
   */
  vendorTeamId: number[]
  /**
   * Filter the date range for report data [From, To]
   * format: date-time
   */
  from?: string
  /**
   * Filter the date range for report data [From, To]
   * format: date-time
   */
  to?: string
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface DownloadPerformanceCrReportParams {
  /**
   * Vendor team ID to get report file
   * format: int32
   */
  vendorTeamId: number[]
  /**
   * Filter the date range for report data [From, To]
   * format: date-time
   */
  from?: string
  /**
   * Filter the date range for report data [From, To]
   * format: date-time
   */
  to?: string
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface DownloadSummaryReportParams {
  /**
   * Vendor team ID to get report file
   * format: int32
   */
   vendorTeamId: number[]
   /**
    * Filter the date range for report data [From, To]
    * format: date-time
    */
   from?: string
   /**
    * Filter the date range for report data [From, To]
    * format: date-time
    */
   to?: string
   /** The requested API version */
   version: string
   /** Country parameter */
   country?: string
}

export interface SendConversationReportParams {
  /** Mail address to send the report file */
  mailAddress: string
  /**
   * Vendor team ID to get report file
   * format: int32
   */
  vendorTeamId: number[]
  /**
   * Filter the date range of report data [From, To]
   * format: date-time
   */
  from?: string
  /**
   * Filter the date range of report data [From, To]
   * format: date-time
   */
  to?: string
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface SendPerformanceCRReportParams {
  /** Mail address to send the report file */
  mailAddress: string
  /**
   * Vendor team ID to get report file
   * format: int32
   */
  vendorTeamId: number[]
  /**
   * Filter the date range of report data [From, To]
   * format: date-time
   */
  from?: string
  /**
   * Filter the date range of report data [From, To]
   * format: date-time
   */
  to?: string
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface SendSummaryReportParams {
  /** Mail address to send the report file */
  mailAddress: string
  /**
   * Vendor team ID to get report file
   * format: int32
   */
  vendorTeamId: number[]
  /**
   * Filter the date range of report data [From, To]
   * format: date-time
   */
  from?: string
  /**
   * Filter the date range of report data [From, To]
   * format: date-time
   */
  to?: string
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface RepliesTimeParams {
  /**
   * Filter date range of the report data [From, To]
   * format: date-time
   */
  from?: string
  /**
   * Filter date range of the report data [From, To]
   * format: date-time
   */
  to?: string
  /**
   * Filter the team data
   * format: int32
   */
  vendorTeamId: number[]
  /**
   * Filter the value for the threshold of response times
   * format: int32
   */
  threshold?: number
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface ConversationLengthParams {
  /**
   * Filter date range of the report data From [From, To]
   * format: date-time
   */
  from?: string
  /**
   * Filter date range of the report data To [From, To]
   * format: date-time
   */
  to?: string
  /**
   * Vendor Team Id - To Filter Data For Team
   * format: int32
   */
  vendorTeamId: number[]
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface ProductCategoriesParams {
  /**
   * Filter date range of the report data From [From, To]
   * format: date-time
   */
  from?: string
  /**
   * Filter date range of the report data To [From, To]
   * format: date-time
   */
  to?: string
  /**
   * Vendor Team Id - To Filter Data For Team
   * format: int32
   */
  vendorTeamId: number[]
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface RatingsParams {
  /**
   * Filter date range of the report data From [From, To]
   * format: date-time
   */
  from?: string
  /**
   * Filter date range of the report data To [From, To]
   * format: date-time
   */
  to?: string
  /**
   * Vendor Team Id - To Filter Data For Team
   * format: int32
   */
  vendorTeamId: number[]
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface ListSavedRepliesParams {
  /** Name of Saved Reply */
  name?: string
  /** format: int32 */
  limit?: number
  /** format: int32 */
  offset?: number
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface CreateSavedReplyParams {
  /** Request Model */
  model?: model.CreateSavedReplyRequestBodyModelV1
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface GetSavedReplyParams {
  /**
   * Saved Reply Id
   * format: int32
   */
  savedReplyId: number
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface UpdateSavedReplyParams {
  /** Model */
  body?: model.UpdateSavedReplyRequestBodyModelV1
  /**
   * Id
   * format: int32
   */
  savedReplyId: number
  /** The requested API version */
  version: string
  /** Country parameter */
  country?: string
}

export interface DeleteSavedReplyParams {
  /**
   * Saved Reply Id
   * format: int32
   */
  savedReplyId: number
  /** The requested API version */
  version: string
}

@Injectable()
export class JeanService {
  constructor(private http: HttpClient) {}

  /**
   * Search for Jean Related Data
  Call for Clients While They Are On Category Or Commodity Detail Page
   * http://undefinedundefined/swagger-ui.html#!/Jean/Search
   */
  Search(params: SearchParams): Observable<model.JeanSearchV1> {
    const queryParamBase = {
      categoryId: params.categoryId,
      commodityId: params.commodityId,
      producers: params.producers,
      url: params.url,
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    const pathParams = {
      version: params.version,
    }
    return this.http.get<model.JeanSearchV1>(`/api/jean/v${pathParams.version}/search`, {params: queryParams})
  }

  /**
   * Get User/Visitor Conversations
   * http://undefinedundefined/swagger-ui.html#!/Jean/GetConversations
   */
  GetConversations(params: GetConversationsParams): Observable<model.ConversationsV1> {
    const queryParamBase = {
      from: params.from,
      limit: params.limit,
      offset: params.offset,
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    const pathParams = {
      version: params.version,
    }
    return this.http.get<model.ConversationsV1>(`/api/jean/v${pathParams.version}/conversations`, {params: queryParams})
  }

  /**
   * Create Jean Conversation
   * http://undefinedundefined/swagger-ui.html#!/Jean/CreateConversation
   */
  CreateConversation(params: CreateConversationParams): Observable<model.ConversationV1> {
    const bodyParams = params.model
    const bodyParamsWithoutUndefined: any = {}
    Object.entries(bodyParams || {}).forEach(([key, value]) => {
      if (value !== undefined) {
        bodyParamsWithoutUndefined[key] = value
      }})
    const pathParams = {
      version: params.version,
    }
    const queryParamBase = {
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    return this.http.post<model.ConversationV1>(`/api/jean/v${pathParams.version}/conversations`, bodyParamsWithoutUndefined, {params: queryParams})
  }

  /**
   * Get User/Visitor Conversation By Conversation Id
   * http://undefinedundefined/swagger-ui.html#!/Jean/GetConversation
   */
  GetConversation(params: GetConversationParams): Observable<model.ConversationV1> {
    const pathParams = {
      conversationId: params.conversationId,
      version: params.version,
    }
    const queryParamBase = {
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    return this.http.get<model.ConversationV1>(`/api/jean/v${pathParams.version}/conversations/${pathParams.conversationId}`, {params: queryParams})
  }

  /**
   * Get All Messages By ConversationId
   * http://undefinedundefined/swagger-ui.html#!/Jean/GetMessages
   */
  GetMessages(params: GetMessagesParams): Observable<model.MessagesV1> {
    const pathParams = {
      conversationId: params.conversationId,
      version: params.version,
    }
    const queryParamBase = {
      from: params.from,
      limit: params.limit,
      offset: params.offset,
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    return this.http.get<model.MessagesV1>(`/api/jean/v${pathParams.version}/conversations/${pathParams.conversationId}/messages`, {params: queryParams})
  }

  /**
   * Create Sound Message - NOT IMPLEMENTED
   * http://undefinedundefined/swagger-ui.html#!/Jean/CreateSoundMessage
   */
  CreateSoundMessage(params: CreateSoundMessageParams): Observable<model.MessageV1> {
    const pathParams = {
      conversationId: params.conversationId,
      version: params.version,
    }
    const bodyParams = params.model
    const bodyParamsWithoutUndefined: any = {}
    Object.entries(bodyParams || {}).forEach(([key, value]) => {
      if (value !== undefined) {
        bodyParamsWithoutUndefined[key] = value
      }})
    const queryParamBase = {
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    return this.http.post<model.MessageV1>(`/api/jean/v${pathParams.version}/conversations/${pathParams.conversationId}/messages`, bodyParamsWithoutUndefined, {params: queryParams})
  }

  /**
   * Get Vendor Team (Expert) Limited
   * http://undefinedundefined/swagger-ui.html#!/Jean/GetVendorTeamLimited
   */
  GetVendorTeamLimited(params: GetVendorTeamLimitedParams): Observable<model.VendorLimitedV1> {
    const pathParams = {
      vendorTeamId: params.vendorTeamId,
      version: params.version,
    }
    const queryParamBase = {
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    return this.http.get<model.VendorLimitedV1>(`/api/jean/v${pathParams.version}/teams/${pathParams.vendorTeamId}`, {params: queryParams})
  }

  /**
   * Get Team/Vendor Conversations
  Roles: TeamMember
  IS Roles: VendorUser
   * http://undefinedundefined/swagger-ui.html#!/Jean/GetVendorConversations
   */
  GetVendorConversations(params: GetVendorConversationsParams): Observable<model.VendorConversationsV1> {
    const queryParamBase = {
      to: params.to,
      open: params.open,
      vendorTeamId: params.vendorTeamId,
      limit: params.limit,
      offset: params.offset,
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    const pathParams = {
      version: params.version,
    }
    return this.http.get<model.VendorConversationsV1>(`/api/jean/v${pathParams.version}/vendor/conversations`, {params: queryParams})
  }

  GetVendorConversationsV2(params: GetVendorConversationsParamsV2): Observable<model.VendorConversationsV1> {
    const queryParamBase = {
      to: params.to,
      conversationState: params.conversationState,
      vendorTeamId: params.vendorTeamId,
      vendorUserId: params.vendorUserId,
      limit: params.limit,
      offset: params.offset,
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    const pathParams = {
      version: params.version,
    }
    return this.http.get<model.VendorConversationsV1>(`/api/jean/v${pathParams.version}/vendor/conversations`, {params: queryParams})
  }

  /**
   * Get All Messages By ConversationId
  Roles: TeamMember
  IS Roles: VendorUser
   * http://undefinedundefined/swagger-ui.html#!/Jean/GetVendorMessages
   */
  GetVendorMessages(params: GetVendorMessagesParams): Observable<model.VendorEventMessagesV1> {
    const pathParams = {
      conversationId: params.conversationId,
      version: params.version,
    }
    const queryParamBase = {
      to: params.to,
      limit: params.limit,
      offset: params.offset,
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    return this.http.get<model.VendorEventMessagesV1>(`/api/jean/v${pathParams.version}/vendor/conversations/${pathParams.conversationId}/messages`, {params: queryParams})
  }

  /**
   * Get Conversation By Conversation Id
  Roles: TeamMember
  IS Roles: VendorUser
   * http://undefinedundefined/swagger-ui.html#!/Jean/GetVendorConversation
   */
  GetVendorConversation(params: GetVendorConversationParams): Observable<model.VendorConversationV1> {
    const pathParams = {
      conversationId: params.conversationId,
      version: params.version,
    }
    const queryParamBase = {
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    return this.http.get<model.VendorConversationV1>(`/api/jean/v${pathParams.version}/vendor/conversations/${pathParams.conversationId}`, {params: queryParams})
  }

  /**
   * Close Conversation
  Roles: TeamMember
  IS Roles: VendorUser
   * http://undefinedundefined/swagger-ui.html#!/Jean/CloseConversation
   */
  CloseConversation(params: CloseConversationParams): Observable<void> {
    const pathParams = {
      conversationId: params.conversationId,
      version: params.version,
    }
    const queryParamBase = {
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    return this.http.patch<void>(`/api/jean/v${pathParams.version}/vendor/conversations/${pathParams.conversationId}`, {}, {params: queryParams})
  }

  /**
   * Get Vendor Conversation Event
  Roles: TeamMember
  IS Roles: VendorUser
   * http://undefinedundefined/swagger-ui.html#!/Jean/GetVendorConversationEvent
   */
  GetVendorConversationEvent(params: EventsParams): Observable<model.ConversationEventV1> {
    const pathParams = {
      conversationId: params.conversationId,
      eventId: params.eventId,
      version: params.version,
    }
    const queryParamBase = {
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    return this.http.get<model.ConversationEventV1>(`/api/jean/v${pathParams.version}/vendor/conversations/${pathParams.conversationId}/events/${pathParams.eventId}`, {params: queryParams})
  }

  /**
   * Get Teams And Team Members To Assign
  Roles: TeamMember
  IS Roles: VendorUser
   * http://undefinedundefined/swagger-ui.html#!/Jean/GetTeamsAndTeamMembersToAssign
   */
  GetTeamsAndTeamMembersToAssign(params: GetTeamsAndTeamMembersToAssignParams): Observable<model.AssigneesV1> {
    const queryParamBase = {
      limit: params.limit,
      offset: params.offset,
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    const pathParams = {
      version: params.version,
    }
    return this.http.get<model.AssigneesV1>(`/api/jean/v${pathParams.version}/vendor/conversations/assignees`, {params: queryParams})
  }

  /**
   * Assign Conversation to Team Member or Team
  Roles: TeamMember
  IS Roles: VendorUser
   * http://undefinedundefined/swagger-ui.html#!/Jean/AssignConversation
   */
  AssignConversation(params: AssignConversationParams): Observable<void> {
    const bodyParams = params.model
    const bodyParamsWithoutUndefined: any = {}
    Object.entries(bodyParams || {}).forEach(([key, value]) => {
      if (value !== undefined) {
        bodyParamsWithoutUndefined[key] = value
      }})
    const pathParams = {
      conversationId: params.conversationId,
      version: params.version,
    }
    const queryParamBase = {
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    return this.http.post<void>(`/api/jean/v${pathParams.version}/vendor/conversations/${pathParams.conversationId}/assignees`, bodyParamsWithoutUndefined, {params: queryParams})
  }

  /**
   * Get All Existing Vendor Teams (Experts)
  Roles: TeamMember
  IS Roles: VendorUser
   * http://undefinedundefined/swagger-ui.html#!/Jean/GetVendorConversationsTeams
   */
  GetVendorConversationsTeams(params: GetVendorConversationsTeamsParams): Observable<model.VendorConversationTeamsV1> {
    const queryParamBase = {
      limit: params.limit,
      offset: params.offset,
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    const pathParams = {
      version: params.version,
    }
    return this.http.get<model.VendorConversationTeamsV1>(`/api/jean/v${pathParams.version}/vendor/conversations/teams`, {params: queryParams})
  }

  /**
   * Get All Existing Vendor Teams (Experts)
  Roles: TeamMember
  IS Roles: VendorUser
   * http://undefinedundefined/swagger-ui.html#!/Jean/GetVendorTeams
   */
  GetVendorTeams(params: GetVendorTeamsParams): Observable<model.VendorTeamsV1> {
    const queryParamBase = {
      limit: params.limit,
      offset: params.offset,
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    const pathParams = {
      version: params.version,
    }
    return this.http.get<model.VendorTeamsV1>(`/api/jean/v${pathParams.version}/vendor/teams`, {params: queryParams})
  }

  /**
   * Create Vendor Team- VendorAdmin Role
  IS Roles: VendorAdmin
   * http://undefinedundefined/swagger-ui.html#!/Jean/CreateVendorTeam
   */
  CreateVendorTeam(params: CreateVendorTeamParams): Observable<model.VendorTeamV1> {
    const bodyParams = params.model
    const bodyParamsWithoutUndefined: any = {}
    Object.entries(bodyParams || {}).forEach(([key, value]) => {
      if (value !== undefined) {
        bodyParamsWithoutUndefined[key] = value
      }})
    const pathParams = {
      version: params.version,
    }
    const queryParamBase = {
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    return this.http.post<model.VendorTeamV1>(`/api/jean/v${pathParams.version}/vendor/teams`, bodyParamsWithoutUndefined, {params: queryParams})
  }

  /**
   * Get Vendor Team (Expert)
  Roles: TeamMember
  IS Roles: VendorUser
   * http://undefinedundefined/swagger-ui.html#!/Jean/GetVendorTeam
   */
  GetVendorTeam(params: GetVendorTeamParams): Observable<model.VendorTeamV1> {
    const pathParams = {
      vendorTeamId: params.vendorTeamId,
      version: params.version,
    }
    const queryParamBase = {
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    return this.http.get<model.VendorTeamV1>(`/api/jean/v${pathParams.version}/vendor/teams/${pathParams.vendorTeamId}`, {params: queryParams})
  }

  /**
   * Update Vendor Team
  Roles: TeamAdmin
  IS Roles: VendorUser
   * http://undefinedundefined/swagger-ui.html#!/Jean/UpdateVendorTeam
   */
  UpdateVendorTeam(params: UpdateVendorTeamParams): Observable<void> {
    const bodyParams = params.model
    const bodyParamsWithoutUndefined: any = {}
    Object.entries(bodyParams || {}).forEach(([key, value]) => {
      if (value !== undefined) {
        bodyParamsWithoutUndefined[key] = value
      }})
    const pathParams = {
      vendorTeamId: params.vendorTeamId,
      version: params.version,
    }
    const queryParamBase = {
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    return this.http.patch<void>(`/api/jean/v${pathParams.version}/vendor/teams/${pathParams.vendorTeamId}`, bodyParamsWithoutUndefined, {params: queryParams})
  }

  /**
   * Upload Vendor Team Image
  Roles: TeamAdmin
  IS Roles: VendorUser
   * http://undefinedundefined/swagger-ui.html#!/Jean/UploadVendorTeamImage
   */
  UploadVendorTeamImage(params: UploadVendorTeamImageParams): Observable<model.VendorTeamImageV1> {
    const bodyParams = params.model
    const bodyParamsWithoutUndefined: any = {}
    Object.entries(bodyParams || {}).forEach(([key, value]) => {
      if (value !== undefined) {
        bodyParamsWithoutUndefined[key] = value
      }})
    const pathParams = {
      vendorTeamId: params.vendorTeamId,
      version: params.version,
    }
    const queryParamBase = {
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    return this.http.patch<model.VendorTeamImageV1>(`/api/jean/v${pathParams.version}/vendor/teams/${pathParams.vendorTeamId}/imgUrl`, bodyParamsWithoutUndefined, {params: queryParams})
  }

  /**
   * Upload Vendor Team Logo Image
  Roles: TeamAdmin
  IS Roles: VendorUser
   * http://undefinedundefined/swagger-ui.html#!/Jean/UploadVendorLogoImage
   */
  UploadVendorLogoImage(params: LogoImgUrlParams): Observable<model.VendorTeamLogoImageV1> {
    const bodyParams = params.model
    const bodyParamsWithoutUndefined: any = {}
    Object.entries(bodyParams || {}).forEach(([key, value]) => {
      if (value !== undefined) {
        bodyParamsWithoutUndefined[key] = value
      }})
    const pathParams = {
      vendorTeamId: params.vendorTeamId,
      version: params.version,
    }
    const queryParamBase = {
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    return this.http.patch<model.VendorTeamLogoImageV1>(`/api/jean/v${pathParams.version}/vendor/teams/${pathParams.vendorTeamId}/logoImgUrl`, bodyParamsWithoutUndefined, {params: queryParams})
  }

  /**
   * Get Vendor Team Opening Hours
  Roles: TeamMember
  IS Roles: VendorUser
   * http://undefinedundefined/swagger-ui.html#!/Jean/GetVendorTeamOpeningHours
   */
  GetVendorTeamOpeningHours(params: GetVendorTeamOpeningHoursParams): Observable<model.OpeningHoursV1> {
    const pathParams = {
      vendorTeamId: params.vendorTeamId,
      version: params.version,
    }
    const queryParamBase = {
      limit: params.limit,
      offset: params.offset,
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    return this.http.get<model.OpeningHoursV1>(`/api/jean/v${pathParams.version}/vendor/teams/${pathParams.vendorTeamId}/openingHours`, {params: queryParams})
  }

  /**
   * Update Vendor Team Opening Hours
  Roles: TeamAdmin
  IS Roles: VendorUser
   * http://undefinedundefined/swagger-ui.html#!/Jean/UpdateVendorTeamOpeningHours
   */
  UpdateVendorTeamOpeningHours(params: UpdateVendorTeamOpeningHoursParams): Observable<void> {
    const bodyParams = params.model
    const bodyParamsWithoutUndefined: any = {}
    Object.entries(bodyParams || {}).forEach(([key, value]) => {
      if (value !== undefined) {
        bodyParamsWithoutUndefined[key] = value
      }})
    const pathParams = {
      vendorTeamId: params.vendorTeamId,
      version: params.version,
    }
    const queryParamBase = {
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    return this.http.patch<void>(`/api/jean/v${pathParams.version}/vendor/teams/${pathParams.vendorTeamId}/openingHours`, bodyParamsWithoutUndefined, {params: queryParams})
  }

  /**
   * Get Vendor Team Rules
  Roles: TeamMember
  IS Roles: VendorUser
   * http://undefinedundefined/swagger-ui.html#!/Jean/GetVendorTeamRules
   */
  GetVendorTeamRules(params: GetVendorTeamRulesParams): Observable<model.VendorTeamRulesV1> {
    const pathParams = {
      vendorTeamId: params.vendorTeamId,
      version: params.version,
    }
    const queryParamBase = {
      limit: params.limit,
      offset: params.offset,
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    return this.http.get<model.VendorTeamRulesV1>(`/api/jean/v${pathParams.version}/vendor/teams/${pathParams.vendorTeamId}/rules`, {params: queryParams})
  }

  /**
   * Create Vendor Team Rule
  Roles: TeamAdmin
  IS Roles: VendorUser
   * http://undefinedundefined/swagger-ui.html#!/Jean/CreateVendorTeamRule
   */
  CreateVendorTeamRule(params: CreateVendorTeamRuleParams): Observable<model.VendorTeamRuleV1> {
    const bodyParams = params.model
    const bodyParamsWithoutUndefined: any = {}
    Object.entries(bodyParams || {}).forEach(([key, value]) => {
      if (value !== undefined) {
        bodyParamsWithoutUndefined[key] = value
      }})
    const pathParams = {
      vendorTeamId: params.vendorTeamId,
      version: params.version,
    }
    const queryParamBase = {
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    return this.http.post<model.VendorTeamRuleV1>(`/api/jean/v${pathParams.version}/vendor/teams/${pathParams.vendorTeamId}/rules`, bodyParamsWithoutUndefined, {params: queryParams})
  }

  /**
   * Get Vendor Team Rule
  Roles: TeamMember
  IS Roles: VendorUser
   * http://undefinedundefined/swagger-ui.html#!/Jean/GetVendorTeamRule
   */
  GetVendorTeamRule(params: GetVendorTeamRuleParams): Observable<model.VendorTeamRuleV1> {
    const pathParams = {
      vendorTeamId: params.vendorTeamId,
      vendorTeamRuleId: params.vendorTeamRuleId,
      version: params.version,
    }
    const queryParamBase = {
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    return this.http.get<model.VendorTeamRuleV1>(`/api/jean/v${pathParams.version}/vendor/teams/${pathParams.vendorTeamId}/rules/${pathParams.vendorTeamRuleId}`, {params: queryParams})
  }

  /**
   * Delete Vendor Team Rule
  Roles: TeamAdmin
  IS Roles: VendorUser
   * http://undefinedundefined/swagger-ui.html#!/Jean/DeleteVendorTeamRule
   */
  DeleteVendorTeamRule(params: DeleteVendorTeamRuleParams): Observable<void> {
    const pathParams = {
      vendorTeamId: params.vendorTeamId,
      vendorTeamRuleId: params.vendorTeamRuleId,
      version: params.version,
    }
    return this.http.delete<void>(`/api/jean/v${pathParams.version}/vendor/teams/${pathParams.vendorTeamId}/rules/${pathParams.vendorTeamRuleId}`)
  }

  /**
   * Update Vendor Team Rule
  Roles: TeamAdmin
  IS Roles: VendorUser
   * http://undefinedundefined/swagger-ui.html#!/Jean/UpdateVendorTeamRule
   */
  UpdateVendorTeamRule(params: UpdateVendorTeamRuleParams): Observable<void> {
    const bodyParams = params.model
    const bodyParamsWithoutUndefined: any = {}
    Object.entries(bodyParams || {}).forEach(([key, value]) => {
      if (value !== undefined) {
        bodyParamsWithoutUndefined[key] = value
      }})
    const pathParams = {
      vendorTeamId: params.vendorTeamId,
      vendorTeamRuleId: params.vendorTeamRuleId,
      version: params.version,
    }
    const queryParamBase = {
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    return this.http.patch<void>(`/api/jean/v${pathParams.version}/vendor/teams/${pathParams.vendorTeamId}/rules/${pathParams.vendorTeamRuleId}`, bodyParamsWithoutUndefined, {params: queryParams})
  }

  /**
   * Get Vendor Team Eshops
  Roles: TeamMember
  IS Roles: VendorUser
   * http://undefinedundefined/swagger-ui.html#!/Jean/GetVendorTeamEshops
   */
  GetVendorTeamEshops(params: GetVendorTeamEshopsParams): Observable<model.VendorTeamEshopsV1> {
    const pathParams = {
      vendorTeamId: params.vendorTeamId,
      version: params.version,
    }
    const queryParamBase = {
      limit: params.limit,
      offset: params.offset,
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    return this.http.get<model.VendorTeamEshopsV1>(`/api/jean/v${pathParams.version}/vendor/teams/${pathParams.vendorTeamId}/eshops`, {params: queryParams})
  }

  /**
   *     Update Vendor Team Eshops
  Roles: TeamAdmin
  IS Roles: VendorUser
   * http://undefinedundefined/swagger-ui.html#!/Jean/UpdateVendorTeamEshops
   */
  UpdateVendorTeamEshops(params: UpdateVendorTeamEshopsParams): Observable<void> {
    const bodyParams = params.model
    const bodyParamsWithoutUndefined: any = {}
    Object.entries(bodyParams || {}).forEach(([key, value]) => {
      if (value !== undefined) {
        bodyParamsWithoutUndefined[key] = value
      }})
    const pathParams = {
      vendorTeamId: params.vendorTeamId,
      version: params.version,
    }
    const queryParamBase = {
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    return this.http.patch<void>(`/api/jean/v${pathParams.version}/vendor/teams/${pathParams.vendorTeamId}/eshops`, bodyParamsWithoutUndefined, {params: queryParams})
  }

  /**
   * Get All TeamMembers
  Roles: TeamMember
  IS Roles: VendorUser
   * http://undefinedundefined/swagger-ui.html#!/Jean/GetTeamMembers
   */
  GetTeamMembers(params: GetTeamMembersParams): Observable<model.TeamMembersV1> {
    const pathParams = {
      vendorTeamId: params.vendorTeamId,
      version: params.version,
    }
    const queryParamBase = {
      limit: params.limit,
      offset: params.offset,
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    return this.http.get<model.TeamMembersV1>(`/api/jean/v${pathParams.version}/vendor/teams/${pathParams.vendorTeamId}/teammembers`, {params: queryParams})
  }

  /**
   * Create Team Member
  Roles: TeamAdmin
  IS Roles: VendorUser
   * http://undefinedundefined/swagger-ui.html#!/Jean/CreateTeamMember
   */
  CreateTeamMember(params: CreateTeamMemberParams): Observable<model.TeamMemberV1> {
    const bodyParams = params.model
    const bodyParamsWithoutUndefined: any = {}
    Object.entries(bodyParams || {}).forEach(([key, value]) => {
      if (value !== undefined) {
        bodyParamsWithoutUndefined[key] = value
      }})
    const pathParams = {
      vendorTeamId: params.vendorTeamId,
      version: params.version,
    }
    const queryParamBase = {
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    return this.http.post<model.TeamMemberV1>(`/api/jean/v${pathParams.version}/vendor/teams/${pathParams.vendorTeamId}/teammembers`, bodyParamsWithoutUndefined, {params: queryParams})
  }

  /**
   * Gets Team Member Data
  Roles: TeamMember
  IS Roles: VendorUser
   * http://undefinedundefined/swagger-ui.html#!/Jean/GetTeamMember
   */
  GetTeamMember(params: GetTeamMemberParams): Observable<model.TeamMemberV1> {
    const pathParams = {
      vendorTeamId: params.vendorTeamId,
      teamMemberId: params.teamMemberId,
      version: params.version,
    }
    const queryParamBase = {
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    return this.http.get<model.TeamMemberV1>(`/api/jean/v${pathParams.version}/vendor/teams/${pathParams.vendorTeamId}/teammembers/${pathParams.teamMemberId}`, {params: queryParams})
  }

  /**
   * Delete Team Member
  Roles: TeamAdmin
  IS Roles: VendorUser
   * http://undefinedundefined/swagger-ui.html#!/Jean/DeleteTeamMember
   */
  DeleteTeamMember(params: DeleteTeamMemberParams): Observable<void> {
    const pathParams = {
      vendorTeamId: params.vendorTeamId,
      teamMemberId: params.teamMemberId,
      version: params.version,
    }
    return this.http.delete<void>(`/api/jean/v${pathParams.version}/vendor/teams/${pathParams.vendorTeamId}/teammembers/${pathParams.teamMemberId}`)
  }

  /**
   * Gets Team Member Roles
  Roles: TeamMember
  IS Roles: VendorUser
   * http://undefinedundefined/swagger-ui.html#!/Jean/GetTeamMemberRoles
   */
  GetTeamMemberRoles(params: GetTeamMemberRolesParams): Observable<model.TeamMemberRolesV1> {
    const pathParams = {
      vendorTeamId: params.vendorTeamId,
      teamMemberId: params.teamMemberId,
      version: params.version,
    }
    const queryParamBase = {
      limit: params.limit,
      offset: params.offset,
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    return this.http.get<model.TeamMemberRolesV1>(`/api/jean/v${pathParams.version}/vendor/teams/${pathParams.vendorTeamId}/teammembers/${pathParams.teamMemberId}/roles`, {params: queryParams})
  }

  /**
   * Get All Vendor Users
  Roles: TeamMember
  IS Roles: VendorUser
   * http://undefinedundefined/swagger-ui.html#!/Jean/GetVendorUsers
   */
  GetVendorUsers(params: GetVendorUsersParams): Observable<model.VendorUsersV1> {
    const queryParamBase = {
      limit: params.limit,
      offset: params.offset,
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    const pathParams = {
      version: params.version,
    }
    return this.http.get<model.VendorUsersV1>(`/api/jean/v${pathParams.version}/vendor/users`, {params: queryParams})
  }

  /**
   * Get Vendor User Data
  Roles: TeamMember
  IS Roles: VendorUser
   * http://undefinedundefined/swagger-ui.html#!/Jean/GetVendorUser
   */
  GetVendorUser(params: GetVendorUserParams): Observable<model.VendorUserV1> {
    const pathParams = {
      vendorUserId: params.vendorUserId,
      version: params.version,
    }
    const queryParamBase = {
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    return this.http.get<model.VendorUserV1>(`/api/jean/v${pathParams.version}/vendor/users/${pathParams.vendorUserId}`, {params: queryParams})
  }

  /**
   * Update Vendor User Data -  TeamAdmin, Or Own User
  Roles: TeamAdmin
  IS Roles: VendorUser
   * http://undefinedundefined/swagger-ui.html#!/Jean/UpdateVendorUser
   */
  UpdateVendorUser(params: UpdateVendorUserParams): Observable<void> {
    const bodyParams = params.model
    const bodyParamsWithoutUndefined: any = {}
    Object.entries(bodyParams || {}).forEach(([key, value]) => {
      if (value !== undefined) {
        bodyParamsWithoutUndefined[key] = value
      }})
    const pathParams = {
      vendorUserId: params.vendorUserId,
      version: params.version,
    }
    const queryParamBase = {
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    return this.http.patch<void>(`/api/jean/v${pathParams.version}/vendor/users/${pathParams.vendorUserId}`, bodyParamsWithoutUndefined, {params: queryParams})
  }

  /**
   * Get Logged In User Data
  Roles: TeamMember
  IS Roles: VendorUser
   * http://undefinedundefined/swagger-ui.html#!/Jean/GetLoggedVendorUser
   */
  GetLoggedVendorUser(params: MeParams): Observable<model.LoggedVendorUserV1> {
    const pathParams = {
      version: params.version,
    }
    const queryParamBase = {
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    return this.http.get<model.LoggedVendorUserV1>(`/api/jean/v${pathParams.version}/vendor/users/me`, {params: queryParams})
  }

  /**
   * Upload User Image File - TeamAdmin, Or Own User
  Roles: TeamAdmin
  IS Roles: VendorUser
   * http://undefinedundefined/swagger-ui.html#!/Jean/UploadVendorUserImage
   */
  UploadVendorUserImage(params: UploadVendorUserImageParams): Observable<model.VendorUserImageV1> {
    const bodyParams = params.model
    const bodyParamsWithoutUndefined: any = {}
    Object.entries(bodyParams || {}).forEach(([key, value]) => {
      if (value !== undefined) {
        bodyParamsWithoutUndefined[key] = value
      }})
    const pathParams = {
      vendorUserId: params.vendorUserId,
      version: params.version,
    }
    const queryParamBase = {
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    return this.http.patch<model.VendorUserImageV1>(`/api/jean/v${pathParams.version}/vendor/users/${pathParams.vendorUserId}/imgUrl`, bodyParamsWithoutUndefined, {params: queryParams})
  }

  /**
   * Get Vendor User Team Roles
  Roles: TeamMember
  IS Roles: VendorUser
   * http://undefinedundefined/swagger-ui.html#!/Jean/GetVendorUserTeamRoles
   */
  GetVendorUserTeamRoles(params: GetVendorUserTeamRolesParams): Observable<model.VendorUserRoleV1> {
    const pathParams = {
      vendorUserId: params.vendorUserId,
      version: params.version,
    }
    const queryParamBase = {
      limit: params.limit,
      offset: params.offset,
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    return this.http.get<model.VendorUserRoleV1>(`/api/jean/v${pathParams.version}/vendor/users/${pathParams.vendorUserId}/roles`, {params: queryParams})
  }

  /**
   * Get Conversation Report Excel File
  Roles: TeamManager, TeamAdmin
   * http://undefinedundefined/swagger-ui.html#!/Jean/DownloadConversationReport
   */
  DownloadConversationReport(params: DownloadConversationReportParams): Observable<string> {
    const queryParamBase = {
      vendorTeamId: params.vendorTeamId,
      from: params.from,
      to: params.to,
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else if (Array.isArray(value)) {
          value.forEach(val => queryParams = queryParams.append(key, val.toString()))
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    const pathParams = {
      version: params.version,
    }
    return this.http.get<string>(`/api/jean/v${pathParams.version}/vendor/reports/downloads/conversation`, {params: queryParams})
  }

  /**
   * Get performance CR report excel file
  Roles: TeamManager, TeamAdmin
   * http://undefinedundefined/swagger-ui.html#!/Jean/DownloadPerformanceCrReport
   */
  DownloadPerformanceCrReport(params: DownloadPerformanceCrReportParams): Observable<string> {
    const queryParamBase = {
      vendorTeamId: params.vendorTeamId,
      from: params.from,
      to: params.to,
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else if (Array.isArray(value)) {
          value.forEach(val => queryParams = queryParams.append(key, val.toString()))
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    const pathParams = {
      version: params.version,
    }
    return this.http.get<string>(`/api/jean/v${pathParams.version}/vendor/reports/downloads/performanceCR`, {params: queryParams})
  }

  /**
   * Send Conversation Report File to Requested Mail
  Roles: TeamManager, TeamAdmin
   * http://undefinedundefined/swagger-ui.html#!/Jean/SendConversationReport
   */
  SendConversationReport(params: SendConversationReportParams): Observable<void> {
    return this.http.post<void>(`/api/jean/v2/vendor/reports/mails/conversation`, params)
  }

  /**
   * Send Performance Conversion Rate Report File To Requested Mail
  Roles: TeamManager, TeamAdmin
   * http://undefinedundefined/swagger-ui.html#!/Jean/SendPerformanceCRReport
   */
  SendPerformanceCRReport(params: SendPerformanceCRReportParams): Observable<void> {
    return this.http.post<void>(`/api/jean/v2/vendor/reports/mails/performanceCR`, params)
  }

    /**
   * Send Summary Report File To Requested Mail
  Roles: TeamManager, TeamAdmin
   * http://undefinedundefined/swagger-ui.html#!/Jean/SendSummaryReport
   */
  SendSummaryReport(params: SendSummaryReportParams): Observable<void> {
    return this.http.post<void>(`/api/jean/v${params.version}/vendor/reports/mails/summary`, params)
  }

  /**
   * Get the reply time for report
  Roles: TeamManager, TeamAdmin
   * http://undefinedundefined/swagger-ui.html#!/Jean/GetRepliesTime
   */
  GetRepliesTime(params: RepliesTimeParams): Observable<model.ReportReplyTimeV1> {
    const queryParamBase = {
      from: params.from,
      to: params.to,
      vendorTeamId: params.vendorTeamId,
      threshold: params.threshold,
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else if (Array.isArray(value)) {
          value.forEach(val => queryParams = queryParams.append(key, val.toString()))
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    const pathParams = {
      version: params.version,
    }
    return this.http.get<model.ReportReplyTimeV1>(`/api/jean/v${pathParams.version}/vendor/reports/repliesTime`, {params: queryParams})
  }

  /**
   * Get closed conversation length for report
  Roles: TeamManager, TeamAdmin
   * http://undefinedundefined/swagger-ui.html#!/Jean/GetConversationLength
   */
  GetConversationLength(params: ConversationLengthParams): Observable<model.ReportConversationLengthV1> {
    const queryParamBase = {
      from: params.from,
      to: params.to,
      vendorTeamId: params.vendorTeamId,
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else if (Array.isArray(value)) {
          value.forEach(val => queryParams = queryParams.append(key, val.toString()))
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    const pathParams = {
      version: params.version,
    }
    return this.http.get<model.ReportConversationLengthV1>(`/api/jean/v${pathParams.version}/vendor/reports/conversationLength`, {params: queryParams})
  }

  /**
   * Get purchased categories among conversations for the report chart
  Roles : TeamManager, TeamAdmin
   * http://undefinedundefined/swagger-ui.html#!/Jean/GetProductCategories
   */
  GetProductCategories(params: ProductCategoriesParams): Observable<model.ProductCategoryV1> {
    const queryParamBase = {
      from: params.from,
      to: params.to,
      vendorTeamId: params.vendorTeamId,
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else if (Array.isArray(value)) {
          value.forEach(val => queryParams = queryParams.append(key, val.toString()))
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    const pathParams = {
      version: params.version,
    }
    return this.http.get<model.ProductCategoryV1>(`/api/jean/v${pathParams.version}/vendor/reports/productCategories`, {params: queryParams})
  }

  /**
   * Get saved replies
   * http://undefinedundefined/swagger-ui.html#!/Jean/ListSavedReplies
   */
  ListSavedReplies(params: ListSavedRepliesParams): Observable<model.SavedRepliesV1> {
    const queryParamBase = {
      name: params.name,
      limit: params.limit,
      offset: params.offset,
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    const pathParams = {
      version: params.version,
    }
    return this.http.get<model.SavedRepliesV1>(`/api/jean/v${pathParams.version}/vendor/savedReplies`, {params: queryParams})
  }

  /**
   * Create saved reply
   * http://undefinedundefined/swagger-ui.html#!/Jean/CreateSavedReply
   */
  CreateSavedReply(params: CreateSavedReplyParams): Observable<model.SavedReplyV1> {
    const bodyParams = params.model
    const bodyParamsWithoutUndefined: any = {}
    Object.entries(bodyParams || {}).forEach(([key, value]) => {
      if (value !== undefined) {
        bodyParamsWithoutUndefined[key] = value
      }})
    const pathParams = {
      version: params.version,
    }
    const queryParamBase = {
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    return this.http.post<model.SavedReplyV1>(`/api/jean/v${pathParams.version}/vendor/savedReplies`, bodyParamsWithoutUndefined, {params: queryParams})
  }

  /**
   * Get saved reply
   * http://undefinedundefined/swagger-ui.html#!/Jean/GetSavedReply
   */
  GetSavedReply(params: GetSavedReplyParams): Observable<model.SavedReplyV1> {
    const pathParams = {
      savedReplyId: params.savedReplyId,
      version: params.version,
    }
    const queryParamBase = {
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    return this.http.get<model.SavedReplyV1>(`/api/jean/v${pathParams.version}/vendor/savedReplies/${pathParams.savedReplyId}`, {params: queryParams})
  }

  /**
   * Update saved reply
   * http://undefinedundefined/swagger-ui.html#!/Jean/UpdateSavedReply
   */
  UpdateSavedReply(params: UpdateSavedReplyParams): Observable<void> {
    const bodyParams = params.body
    const bodyParamsWithoutUndefined: any = {}
    Object.entries(bodyParams || {}).forEach(([key, value]) => {
      if (value !== undefined) {
        bodyParamsWithoutUndefined[key] = value
      }})
    const pathParams = {
      savedReplyId: params.savedReplyId,
      version: params.version,
    }
    const queryParamBase = {
      country: params.country,
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    return this.http.put<void>(`/api/jean/v${pathParams.version}/vendor/savedReplies/${pathParams.savedReplyId}`, bodyParamsWithoutUndefined, {params: queryParams})
  }

  /**
   * Delete saved reply
   * http://undefinedundefined/swagger-ui.html#!/Jean/DeleteSavedReply
   */
  DeleteSavedReply(params: DeleteSavedReplyParams): Observable<void> {
    const pathParams = {
      savedReplyId: params.savedReplyId,
      version: params.version,
    }
    return this.http.delete<void>(`/api/jean/v${pathParams.version}/vendor/savedReplies/${pathParams.savedReplyId}`)
  }

  GetRatings(params: RatingsParams): Observable<model.ReportChatRatingV1> {
    const queryParamBase = {
      from: params.from,
      to: params.to,
      vendorTeamId: params.vendorTeamId,
      country: params.country
    }

    let queryParams = new HttpParams()
    Object.entries(queryParamBase).forEach(([key, value]) => {
      if (value !== undefined) {
        if (typeof value === 'string') {
          queryParams = queryParams.set(key, value)
        } else if (Array.isArray(value)) {
          value.forEach(val => queryParams = queryParams.append(key, val.toString()))
        } else {
           queryParams = queryParams.set(key, JSON.stringify(value))
        }
      }
    })

    const pathParams = {
      version: params.version,
    }

    return this.http.get<model.ReportChatRatingV1>(`/api/jean/v${pathParams.version}/vendor/reports/chatRatings`, {params: queryParams})
  }
}



// WEBPACK FOOTER //
// ./src/app/api/api/services/jean.service.ts